"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconPosition = void 0;
var tslib_1 = require("tslib");
// (C) 2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var sdk_model_1 = require("@gooddata/sdk-model");
var uuid_1 = require("uuid");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var ColorOverlay_1 = tslib_1.__importStar(require("./ColorOverlay"));
var ColorPalette_1 = tslib_1.__importDefault(require("./ColorPalette"));
var CustomColorButton_1 = tslib_1.__importDefault(require("./CustomColorButton"));
var IconPosition;
(function (IconPosition) {
    IconPosition[IconPosition["Down"] = 0] = "Down";
    IconPosition[IconPosition["Right"] = 1] = "Right";
})(IconPosition = exports.IconPosition || (exports.IconPosition = {}));
var COLOR_FOR_UNKNOWN_ITEM = {
    r: 255,
    g: 0,
    b: 0,
};
var ColorDropdown = /** @class */ (function (_super) {
    tslib_1.__extends(ColorDropdown, _super);
    function ColorDropdown(props) {
        var _this = _super.call(this, props) || this;
        _this.onColorPickerSubmit = function (color) {
            var item = {
                type: "rgb",
                value: color,
            };
            _this.onColorSelected(item);
        };
        _this.onColorPickerCancel = function () {
            _this.setState({ dropdownVersion: ColorOverlay_1.DropdownVersionType.ColorPalette });
        };
        _this.onCustomColorButtonClick = function () {
            _this.setState({ dropdownVersion: ColorOverlay_1.DropdownVersionType.ColorPicker });
        };
        _this.onClose = function () {
            _this.setState({ isDropdownOpen: false, dropdownVersion: ColorOverlay_1.DropdownVersionType.ColorPalette });
        };
        _this.onDropdownButtonClick = function () {
            _this.toggleDropdown();
        };
        _this.onColorSelected = function (color) {
            _this.setState({
                isDropdownOpen: false,
                dropdownVersion: ColorOverlay_1.DropdownVersionType.ColorPalette,
            });
            setTimeout(function () {
                _this.props.onColorSelected(color);
            }, 100);
        };
        _this.id = uuid_1.v4();
        _this.state = {
            isDropdownOpen: false,
            dropdownVersion: ColorOverlay_1.DropdownVersionType.ColorPalette,
        };
        return _this;
    }
    ColorDropdown.prototype.render = function () {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: this.getClassName(), onClick: this.onDropdownButtonClick }, this.setupDropdownChild()),
            this.state.isDropdownOpen && (react_1.default.createElement(ColorOverlay_1.default, { alignTo: "." + this.getClassName(), onClose: this.onClose, dropdownVersion: this.state.dropdownVersion, key: this.state.dropdownVersion },
                react_1.default.createElement("div", { className: "overlay dropdown-body" }, this.isColorPaletteContent()
                    ? this.renderColorPaletteContent()
                    : this.renderColorPickerContent())))));
    };
    ColorDropdown.prototype.setupDropdownChild = function () {
        var childProps = {
            isSelected: this.state.isDropdownOpen,
            position: this.getIconPosition(),
        };
        return react_1.default.cloneElement(this.props.children, childProps);
    };
    ColorDropdown.prototype.getIconPosition = function () {
        return this.state.dropdownVersion === ColorOverlay_1.DropdownVersionType.ColorPalette
            ? IconPosition.Down
            : IconPosition.Right;
    };
    ColorDropdown.prototype.isColorPaletteContent = function () {
        return this.state.dropdownVersion === ColorOverlay_1.DropdownVersionType.ColorPalette;
    };
    ColorDropdown.prototype.renderColorPaletteContent = function () {
        return (react_1.default.createElement("div", { className: "gd-color-drop-down" },
            react_1.default.createElement(ColorPalette_1.default, { selectedColorGuid: this.getSelectedGuidFromColorItem(), colorPalette: this.props.colorPalette, onColorSelected: this.onColorSelected }),
            this.props.showCustomPicker && react_1.default.createElement(CustomColorButton_1.default, { onClick: this.onCustomColorButtonClick })));
    };
    ColorDropdown.prototype.getSelectedGuidFromColorItem = function () {
        if (sdk_model_1.isColorFromPalette(this.props.selectedColorItem)) {
            return this.props.selectedColorItem.value;
        }
        return null;
    };
    ColorDropdown.prototype.renderColorPickerContent = function () {
        return (react_1.default.createElement(sdk_ui_kit_1.ColorPicker, { initialRgbColor: this.getSelectedColorFromPalette(), onSubmit: this.onColorPickerSubmit, onCancel: this.onColorPickerCancel }));
    };
    ColorDropdown.prototype.getSelectedColorFromPalette = function () {
        var _this = this;
        if (sdk_model_1.isColorFromPalette(this.props.selectedColorItem)) {
            var selected = this.props.colorPalette.find(function (item) {
                return item.guid === _this.props.selectedColorItem.value;
            });
            if (selected) {
                return selected.fill;
            }
        }
        if (sdk_model_1.isRgbColor(this.props.selectedColorItem)) {
            return this.props.selectedColorItem.value;
        }
        return COLOR_FOR_UNKNOWN_ITEM;
    };
    ColorDropdown.prototype.getClassName = function () {
        return "s-color-drop-down-button-" + this.id;
    };
    ColorDropdown.prototype.toggleDropdown = function () {
        this.setState({
            isDropdownOpen: !this.state.isDropdownOpen,
            dropdownVersion: ColorOverlay_1.DropdownVersionType.ColorPalette,
        });
    };
    return ColorDropdown;
}(react_1.default.PureComponent));
exports.default = react_intl_1.injectIntl(ColorDropdown);
//# sourceMappingURL=ColorDropdown.js.map